import Header from "./Header";
import Footer from "./Footer";
import SnsFloating from "./SnsFloating";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col font-sans">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <SnsFloating />
    </div>
  );
}